/* ============================================================
   spn-machine-related.js — 機種ページの「同じメーカーの機種」「あわせて見られている機種」
   移植元: assets/machines.js renderMachineByMaker / renderMachineRelatedPopular
   前提: spn-machines-data.js → spn-machine-core.js の後に読み込む（window.SPN_MACHINES）
   ============================================================ */
(function () {
  "use strict";
  var M = window.SPN_MACHINES;
  var slug = window.SPN_CURRENT_MACHINE;
  if (!M || !slug) return;
  var current = M.findMachine(slug);

  var byMakerEl = document.querySelector("[data-spn-related='by-maker']");
  // サーバー側（Liquid）で出し済みなら触らない（data-spn-ssr。2026-10-16 E16）
  if (byMakerEl && current && !byMakerEl.hasAttribute("data-spn-ssr")) {
    var others = M.machinesByMaker(current.maker, current.slug, 8, current.machine_type);
    if (others.length) {
      var maker = M.makerName(current.maker);
      byMakerEl.innerHTML =
        '<div class="section-head"><h2>' + M.escapeHtml(maker) + " の他の" + M.TYPE_LABEL[current.machine_type] + "対応機種</h2>" +
        '<a href="' + M.makerUrl(current.maker) + '" class="more">' + M.escapeHtml(maker) + " 全機種を見る →</a></div>" +
        '<div class="machine-card-list">' + others.map(M.cardHtml).join("") + "</div>";
    } else {
      byMakerEl.closest("section").remove();
    }
  }

  var popEl = document.querySelector("[data-spn-related='popular']");
  if (popEl) {
    var pops = M.popularMachines(slug, 4);
    if (pops.length) {
      popEl.innerHTML = '<div class="section-head"><h2>あわせて見られている機種</h2></div>' +
        '<div class="machine-card-list">' + pops.map(M.cardHtml).join("") + "</div>";
    } else {
      popEl.closest("section").remove();
    }
  }
})();
